module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-cart-delivery-notes-form-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-notes-form-title">Notes</div>\n          <div class="fmcy-cart-delivery-notes-form-header">Anything extra we should know regarding this order?</div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <textarea class="fmcy-cart-delivery-notes-textbox form-control" name="deliveryNotes" id="fmcy-cart-delivery-notes-textbox-'+
((__t=( viewId ))==null?'':__t)+
'" placeholder="" rows="3" maxlength="300"></textarea>\n              <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-notes-form.html
 ** module id = 644
 ** module chunks = 1 9 15 185
 **/